<template>
    <div>
        <div
            class="goodsListFloor"
            v-track:exposure :track-params="JSON.stringify({event: 109, floorName: item.name})"
            v-for="item in floors"
            :key="item.id"
            v-show="item.spus && item.spus.length || item.pictureLinkList.length"
        >
            <div class="titleHeader">
                <div class="title">{{item.name}}</div>
                <div class="more" @click="floorMore(item)" v-show="item.templateType === 10">
                    <span class="tip" v-track:click :track-params="JSON.stringify({event: 110, floorName: item.name})">更多</span>
                    <span class="icon"></span>
                </div>
            </div>
            <div class="goodList" v-track:click :track-params="JSON.stringify({event: 110, floorName: item.name})" v-show="item.templateType === 10">
                <div class="goodLi" :class="{'hot': subItem.isFaddish == 1}" v-for="(subItem, index) in item.spus" v-show="index < 6" :key="subItem.spuId" @click="onDetail(subItem.spuId)">
                    <div class="img">
                        <img v-lazy="$viewImageNew(subItem.pictureUrl, 400,400)" alt="">
                    </div>
                    <div class="content">
                        <div class="name">
                            {{subItem.spuName}}
                        </div>
                        <div class="fot">
                            <div class="saleP" v-if="$isPriceShow()"><i class="icon"></i><i>￥</i>{{ subItem.sellPrice }}</div>
                            <div class="saleP isPrice" v-else>会员价</div>
                            <Tags v-if="subItem.productTags.length" :tagsArr='subItem.productTags' />
                        </div>
                    </div>
                </div>
            </div>
            <div class="bannerList" v-if="item.templateType === 20">
                <div class="bannerList_img" v-for="bannerItem in item.pictureLinkList" :key="bannerItem.sort" @click="onBanerUrl(bannerItem.linkUrl)">
                    <img v-lazy="$viewImageNew(bannerItem.pictureUrl, 1000, 327)" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tags from '../../common/Tags'
export default {
    components: {
        Tags
    },
    props: {
        floors: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        floorMore (item) {
            this.$emit('floorMore', item)
        },
        onDetail (item) {
            this.$emit('floorClick', item)
        },
        onBanerUrl (url) {
            // this.$router.push({ path: url })
            this.$emit('bannerUrl', url)
        }
    },
    mounted () {
        console.log(this.floors)
    }
}
</script>

<style lang="scss" scoped>
.goodsListFloor {
    padding: 18px 24px 6px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    .titleHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.pr20 {
            padding-right: 20px;
        }
        .title {
            font-family: PingFangSC;
            font-weight: bold;
            font-size: 34px;
            line-height: 48px;
            color: #333333;
        }
        .more {
            font-size: 26px;
            line-height: 36px;
            color: #888888;
            display: flex;
            align-items: center;
            .icon {
                width: 40px;
                height: 40px;
                background: url(../../../../assets/img/b2b/img_arrow_next@2x.png)
                    no-repeat;
                background-size: cover;
            }
        }
    }
    .goodList {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 24px;
        width: 101%;
        .goodLi {
            width: 230px;
            background: #ffffff;
            border-radius: 4px;
            padding-top: 38px;
            margin-right: 6px;
            position: relative;
            overflow: hidden;
            &:nth-child(-n + 3) {
                padding-top: 0;
            }
            .img {
                width: 100%;
                height: 230px;
                vertical-align: bottom;
                position: relative;
                display: flex;
                background-color: #fafafa;
                img {
                    display: inline-block;
                    align-self: center;
                    justify-self: center;
                    margin: 0 auto;
                    background: #f5f5f5;
                    object-fit: cover;
                }
            }
            .content {
                padding: 16px 0 0;
                .name {
                    height: 40px;
                    line-height: 40px;
                    font-size: 24px;
                    padding-right: 14px;
                    margin-bottom: 6px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
                .saleP {
                    width: 100%;
                    height: 32px;
                    font-size: 32px;
                    line-height: 32px;
                    margin-bottom: 4px;
                    font-weight: bold;
                    color: #ff571f;
                    font-family: Helvetica;
                    i {
                        display: inline-block;
                        font-size: 24px;
                        transform: scale(0.92);
                        transform-origin: left -130%;
                    }
                    &.isPrice {
                        font-size: 28px;
                    }
                }
            }
        }
    }
    .bannerList {
        font-size: 0;
        margin-top: 24px;
        &_img {
            width: 100%;
            height: 230px;
            margin-bottom: 16px;
            display: flex;
            img {
                border-radius: 16px;
                display: inline-block;
                align-self: center;
                justify-self: center;
                margin: 0 auto;
                background: #f5f5f5;
                object-fit: cover;
                height: 100%;
            }
        }
    }
}
</style>